import _extends from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import useSWRImmutable from 'swr/immutable';
import styled from 'styled-components';
import * as core from '@bob/core-services';
import * as ds from '@bob/design-system';
import * as url from '@bob/url';
import * as utils from '@bob/utils';
import * as money from '@bob/money';
export function StarProducts(_ref) {
  var _brand$identifier, _brand$identifier2;

  var brand = _ref.brand;

  var _useSWRImmutable = useSWRImmutable(brand.isDistributed ? ["star-products-".concat(brand.slug), (_brand$identifier = brand.identifier) !== null && _brand$identifier !== void 0 ? _brand$identifier : brand.name] : null, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, vendor) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return core.product.client.getMediumProductsWithDescription({
                first: 4,
                query: "(tag:star OR tag:Star) AND vendor:".concat(vendor)
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
      starProducts = _useSWRImmutable.data;

  if (!brand.isDistributed) return __jsx(React.Fragment, null);
  return __jsx(Container, null, starProducts && starProducts.length > 0 && __jsx(React.Fragment, null, __jsx(ds.styles.heading.Title3, null, "Articles phares"), __jsx(ds.LineGridLayout, null, starProducts.map(function (product) {
    var _ref3, _test$textContent;

    var test = document.createElement('div');
    test.innerHTML = product.description;
    var description = (_ref3 = (_test$textContent = test.textContent) !== null && _test$textContent !== void 0 ? _test$textContent : test.innerText) !== null && _ref3 !== void 0 ? _ref3 : '';

    var cardProduct = _objectSpread(_objectSpread({}, product), {}, {
      priceRange: [money.format(product.priceRange[0]), money.format(product.priceRange[1])]
    });

    return __jsx(ds.ProductCard, _extends({
      key: product.id
    }, cardProduct, {
      compareAtPriceRange: cardProduct.compareAtPriceRange ? [money.format(cardProduct.compareAtPriceRange[0]), money.format(cardProduct.compareAtPriceRange[1])] : undefined,
      description: description,
      criteria: _toConsumableArray(product.criteria.environmental.map(function (criterion) {
        return {
          name: criterion.name,
          icon: utils.symbols.getCriterionSymbolName(criterion)
        };
      }))
    }));
  }))), __jsx(ds.ButtonAsLink, {
    href: "".concat(url.products({
      title: ''
    }).path, "?brands=").concat(utils.text.slugify((_brand$identifier2 = brand.identifier) !== null && _brand$identifier2 !== void 0 ? _brand$identifier2 : brand.name, '-'))
  }, "D\xE9couvrir les produits ".concat(brand.name)));
}
var Container = styled(ds.Container).withConfig({
  displayName: "StarProducts__Container",
  componentId: "sc-v00llr-0"
})(["display:flex;flex-direction:column;", "{margin-bottom:20px;margin-top:60px;}", "{margin:auto;margin-top:40px;}"], ds.styles.heading.Title3, ds.ButtonAsLink);